import React, { Component } from "react";

class Tab extends Component {
    render() {
        return (
            <div
                role="tabpanel"
                id={"panel"}
                tabIndex={0}
                aria-labelledby={`tab-${this.props.label}`}
                aria-label={this.props.label}
                className="tabs__content-inner"
            >
                {this.props.children}
            </div>
        );
    }
}

export default Tab;
